<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement" style="padding-top:100px">
<p style="text-indent:0em">My worst nightmare is being beaten up in the streets, naked, because I have just released a book based on a mathematical and, by definition, a philosophical theory that does not exist.</p><br/>
<p style="text-indent:0em">This has had grave consequences on various aspects of quantum physics, mathematics and philosophy and music into the bargain. It has been a best seller, and I am rich and famous.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?429270af